// extracted by mini-css-extract-plugin
export default {"Card":"Card_Card__PL0qO","visibleCard":"Card_visibleCard__HFtjc"};